<template>
  <div class="home">
    THIS TOOL: <a href="https://github.com/sinfere/bkv-js-tool"
                  target="_blank">https://github.com/sinfere/bkv-js-tool</a>
    <div class="clear-10"></div>
    BKV-C: <a href="https://github.com/sinfere/light-bkv-c" target="_blank">https://github.com/sinfere/light-bkv-c</a>
    <div class="clear-10"></div>
    BKV-JAVA: <a href="https://github.com/sinfere/bkv-java" target="_blank">https://github.com/sinfere/bkv-java</a>
    <div class="clear-10"></div>
    BKV-GO: <a href="https://github.com/sinfere/bkv-go" target="_blank">https://github.com/sinfere/bkv-go</a>
    <div class="clear-10"></div>
    BKV-JS: <a href="https://github.com/sinfere/bkv-js" target="_blank">https://github.com/sinfere/bkv-js</a>
  </div>
</template>

<script>
export default {
  name: 'home',
  components: {}
}
</script>
